import VueJwtDecode from 'vue-jwt-decode'
import axios from "axios"
import constants from "../constants";


function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}

function getJWT(){
    return 'JWT ' + localStorage.getItem('jwt');
}

function getJWTContent(){
    let jwt = localStorage.getItem('jwt')
    return VueJwtDecode.decode(jwt)
}

function getHeaders(){
    return {
        headers: {
            "Authorization" : getJWT(),
            "Content-Type": "application/json"
        }
    }
}

function isMobile(){
   return window.innerWidth <= 768
}

function getUserPlan(){
    let user = getJWTContent()
    return axios.get(
        constants.API_URL + "users/" + user["id"] + "/plan/",
        getHeaders()
    )
}

export {
    uuidv4,
    getJWT,
    getHeaders,
    isMobile,
    getJWTContent,
    getUserPlan,
}